import React from 'react';
import PropTypes from 'prop-types';
import Svg from './Svg';

const arrowType = 'arrow';
class ArrowSvg extends Svg {
	constructor(props) {
		super(props);
	}

	getPlainSVG(xrotation, color, opacity) {
		let rotation = "rotate(" + xrotation + " 256 256)";
		return(
			<svg id={arrowType} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512">
				<g transform={rotation}>
					<circle fill="#FFFFFF" opacity={opacity} className="st1" cx="230" cy="230" r="230"/>
					<circle fill="#FFFFFF" opacity={opacity} className="st2" cx="230" cy="230" r="230"/>
					<path fill={color} opacity={opacity} className="st3" d="M358.993479,296.688968 C356.06112,300.124017 352.458508,301.045616 348.688332,299.369982 
					C347.180261,298.699729 333.021156,284.791969 288.197955,239.884985 L229.634556,181.321587 L171.322503,239.63364 
					C139.234118,271.722026 112.423978,298.364602 111.669943,298.867292 C108.318676,301.129398 104.129591,300.542926 100.778324,297.191658 
					L98.6,295.013334 L98.6,290.991814 L98.6,286.970293 L161.520046,224.050247 C199.640713,185.92958 225.110345,160.795074 226.115726,160.292384 
					C231.142627,157.778933 232.148007,158.449187 249.825943,176.127123 C258.204111,184.505291 265.241773,191.375389 265.5769,191.375389 
					C265.912026,191.375389 266.07959,191.626734 266.07959,191.878079 C266.07959,192.548333 273.368596,199.83734 274.03885,199.83734 
					C274.290195,199.83734 274.54154,200.004903 274.54154,200.256248 C274.54154,200.84272 285.349377,211.818121 286.019631,211.818121 
					C286.354758,211.818121 286.606103,211.985684 286.606103,212.237029 C286.606103,212.823501 305.959672,232.260852 306.546144,232.260852 
					C306.797489,232.260852 307.048834,232.428415 307.048834,232.763542 C307.048834,233.014887 319.113397,245.330795 333.942755,260.076372 
					L360.836676,286.970293 L360.836676,290.82425 C360.669113,294.761989 360.669113,294.761989 358.993479,296.688968"/>
				</g>
			</svg>
		);
	}

}

ArrowSvg.propTypes = {
	primaryColor: PropTypes.string.isRequired,
	rotation: PropTypes.number.isRequired
};

export default ArrowSvg;
